import { Col, Grid, Link, Row } from "@george-labs.com/design-system"
import "./Footer.css"

export default function Footer() {
  return (
    <div className="footer d-none d-lg-block">
      <Grid fluid={false} className="d-flex h-100 align-items-center">
        <Row>
          <Col>
            <div className="footer-content">
              <img src="./logo.svg" alt="" width="auto" height="auto" />
              <div className="links">
                <Link
                  href="https://www.erstebank.hu/hu/impresszum"
                  className="footer-link"
                  target="_blank"
                >
                  Impresszum
                </Link>
                <Link
                  href="https://gate.erstebank.hu/aszf"
                  className="footer-link"
                  target="_blank"
                >
                  Általános szerződési feltételek (ÁSZF)
                </Link>
                <Link
                  href="https://www.erstebank.hu/hu/adatkezelesi"
                  className="footer-link"
                  target="_blank"
                >
                  Személyes adatok védelme
                </Link>
              </div>
            </div>
          </Col>
        </Row>
      </Grid>
    </div>
  )
}
